<template>
    <div>
      <h2 class="text-2xl font-bold mb-4">Configuración de Entrevista</h2>
      <p class="mb-4">
          Bienvenido al asistente de configuración de entrevistas. Sigue los pasos para configurar tu entrevista de la mejor manera.
      </p>
    </div>
  </template>
  <script>
  export default {
      
  }
  </script>